import { FONT_FAMILY, FONT_WEIGHT } from '@constants/fonts.ts';
import type { CHANGE_TYPE } from '@routes/sidebar/learning/ui/dashboard-tab/___shared___/utils.ts';
import { STATISTICS_CHANGE_TYPE } from '@routes/sidebar/learning/ui/dashboard-tab/___shared___/utils.ts';
import styled from 'styled-components';

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const Title = styled.div`
    margin: 0;
    ${FONT_FAMILY.poppins};
    font-weight: 400;
    font-size: 14px;
    color: rgba(3, 2, 41, 1);
    opacity: 0.7;
`;

export const Details = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const SummarizeScore = styled.span`
    ${FONT_FAMILY.poppins};
    font-size: 22px;
    font-weight: 800;
    color: #000;
    opacity: 0.7;
`;

export const Progress = styled.div<{ type: CHANGE_TYPE }>`
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: 'Inter', 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ type }) =>
        type === STATISTICS_CHANGE_TYPE.INCREASE
            ? '#008c00'
            : type === STATISTICS_CHANGE_TYPE.DECREASE
              ? '#ef4444'
              : '#3E445C'};
`;

export const GamificationSectionItemWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
`;

export const IconWrapper = styled.div`
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: relative;
`;

export const IconText = styled.span`
    ${FONT_FAMILY.poppins};
    ${FONT_WEIGHT.bold}
    font-size: 12px;
    color: var(--colors-teal-400);
    padding-top: 19px;
    margin-left: -4px;
`;
